/* ==========================================================================
   HAUSS (DAR) - barra fija de compra en movil. Origen: biblioteca DAR dar-sticky-atc-universal.
   Pixel-safe: no llama a /cart/add. Hace scroll al boton nativo y le da .click(): el agregar sale del
   mismo flujo de siempre (product-buttons -> theme:cart:add de Broadcast -> CMX).
   ========================================================================== */
(function () {
  'use strict';
  var MQ = window.matchMedia('(max-width: 768px)');

  function init() {
    var bar = document.querySelector('[data-hc-satc]');
    if (!bar || bar.getAttribute('data-ready') === '1') return;
    var addBtn = document.querySelector('form[action*="/cart/add"] [data-add-to-cart]') || document.querySelector('form[action*="/cart/add"] [name="add"]');
    if (!addBtn) return;
    bar.setAttribute('data-ready', '1');
    var form = addBtn.closest('form');
    var btn = bar.querySelector('[data-hc-satc-btn]');
    var priceEl = bar.querySelector('[data-hc-satc-price]');
    var variantEl = bar.querySelector('[data-hc-satc-variant]');
    var nativeOut = false;
    var footerIn = false; // con el footer a la vista la barra se oculta (sin franja blanca al final de la pagina)

    function cmxOpen() {
      var d = document.getElementById('cmx-drawer');
      return !!(d && d.classList.contains('is-open'));
    }
    function render() {
      var show = MQ.matches && nativeOut && !footerIn && !cmxOpen();
      bar.hidden = !show;
      bar.classList.toggle('is-in', show);
      document.documentElement.classList.toggle('hc-satc-on', show);
    }
    // Copia del boton nativo: precio (suscripcion/cantidad) y estado agotado
    function sync() {
      // Precio visible del boton: sin el tachado ni el texto oculto para lectores de pantalla
      var p = addBtn.querySelector('.product__price, .product-price, [data-price-wrapper]');
      var txt = '';
      if (p) {
        var c = p.cloneNode(true);
        Array.prototype.forEach.call(c.querySelectorAll('.visually-hidden, s, [data-compare-price], .hidden'), function (n) { n.remove(); });
        txt = c.textContent.replace(/\s+/g, ' ').trim();
      }
      if (priceEl) priceEl.textContent = txt;
      if (btn) btn.disabled = !!addBtn.disabled;
      if (variantEl && form) {
        // Los radios de Broadcast viven fuera del <form> (atributo form=), por eso form.elements
        var checked = Array.prototype.filter.call(form.elements, function (i) { return i.type === 'radio' && i.checked && /^options\[/.test(i.name); }).map(function (i) { return i.value; });
        if (checked.length) variantEl.textContent = checked.join(' / ');
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        nativeOut = !e.isIntersecting && e.boundingClientRect.top < 0;
        render();
      }, { rootMargin: '0px 0px -40px 0px' }).observe(addBtn);
      var foot = document.querySelector('.footer-sections, footer.site-footer-wrapper, footer');
      if (foot) new IntersectionObserver(function (entries) { footerIn = entries[0].isIntersecting; render(); }).observe(foot);
    }
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(addBtn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('change', function (e) { if (e.target && e.target.form === form) setTimeout(sync, 60); });
      var drawer = document.getElementById('cmx-drawer');
      if (drawer) new MutationObserver(render).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    if (MQ.addEventListener) MQ.addEventListener('change', render);
    sync();

    if (btn) btn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(function () { addBtn.click(); }, 320);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
